import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './input.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <App />
);

